<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 15:58:03
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-16 14:21:01
 * @FilePath: /goldenSalesMobile/src/views/UsersAccountCenter/index.vue
 * @Description: 消费者个人中心
-->
<template>
  <div class='page-container'>
    <van-form
      class="login-form"
      @submit="onSubmit"
      :show-error="false"
    >

      <van-cell title="头像">
        <img
          class="avatar"
          :src="headImageUrl ? headImageUrl : require('../../assets/account_image/avatar.png')"
          alt=""
        >
      </van-cell>

      <van-field
        v-model="username"
        label="用户名"
        placeholder="填写昵称"
        input-align="right"
      />

      <van-field
        v-model="birthday"
        is-link
        label="生日"
        placeholder="选择"
        @focus="onDisplay"
        input-align="right"
      />
      <!--      <van-cell-->
      <!--              title="生日"-->
      <!--              v-model="birthday"-->
      <!--              @click="onDisplay"-->
      <!--              placeholder="填写生日"-->
      <!--      />-->
      <van-calendar
        v-model="showBirthday"
        @close="onClose"
        @confirm="onConfirm"
      />

      <van-field
        v-model="sex"
        is-link
        label="性别"
        placeholder="选择"
        @focus="onSexFocus"
        input-align="right"
      />
      <van-action-sheet
        v-model="showSex"
        :round="false"
        :actions="sexes"
        @select="onSelect"
      />

      <van-cell
        v-model="phone"
        title="手机号"
        is-link
        @click="onPhoneClick"
      />

      <van-button
        round
        block
        color="linear-gradient(to right, #FA9B00, #FBCA39)"
        native-type="submit"
        style="position: fixed;bottom: 10px"
      >
        保存
      </van-button>
    </van-form>
  </div>
</template>

<script>
import { getConsumerInfo, putConsumerInfo } from '@/api/user'
import ChangePhone from '@/views/UsersAccountCenter/changephone'
export default {
  data() {
    return {
      headImageUrl: '',
      username: '',
      birthday: '',
      showBirthday: false,
      sex: '',
      showSex: false,
      sexes: [
        { name: '男', value: 0 },
        { name: '女', value: 1 },
      ],
      phone: '',
    }
  },
  components: {
    ChangePhone
  },
  created() {
    this.init()
  },

  methods: {
    // 获取消费者信息
    init() {
      getConsumerInfo()
        .then(res => {
          this.headImageUrl = res.HeadImageUrl;
          this.username = res.UserName;
          if (res.Birthday) this.birthday = this.formatDate(res.Birthday);
          if (res.Sex || res.Sex == 0) this.sex = res.Sex == 0 ? '男' : '女';
          this.phone = res.Phone;
        })
    },

    onDisplay() {
      this.showBirthday = true;
    },
    onClose() {
      this.showBirthday = false;
    },
    formatDate(date) {
      date = new Date(date);
      return `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate() + 1}`;
    },
    onConfirm(date) {
      this.showBirthday = false;
      this.birthday = this.formatDate(date);
    },
    onSexFocus() {
      this.showSex = true;
    },
    onSelect(item) {
      this.showSex = false;
      this.sex = item.name;
    },
    onPhoneClick() {
      this.$router.push({
        name: 'ChangePhone'
      })
    },

    onSubmit() {
      putConsumerInfo({ UserName: this.username, Sex: this.sex == '男' ? 0 : 1, Birthday: this.birthday, HeadImageUrl: this.headImageUrl })
        .then(res => {
          if (res) {
            this.$router.push({
              name: 'UsersAccountCenter'
            })
          }
          // if (res.UserId && res.Token) {
          //   sessionStorage.setItem('userPhone', values.phone)
          //   setToken(res.Token)
          //   if (res.IsDistributor) { // 销售员
          //     localStorage.setItem('userRole', 'distributor')
          //   } else { // 消费者
          //     localStorage.setItem('consumerId', res.UserId)
          //     localStorage.setItem('userRole', 'consumer')
          //   }
          //
          //   // 登录成功后跳转，根据场景指定
          //   if (sessionStorage.getItem('pageBeforeLogin') === 'submitOrder') { // 提交订单
          //     this.$router.replace('/submit-order')
          //   } else if (sessionStorage.getItem('pageBeforeLogin') === 'checkMyOrder') { // 查看订单
          //     this.$router.replace('/users-order')
          //   } else {
          //     this.$router.replace('/users/shopping-list')
          //   }
          // }
        })
        .catch(err => {
          // console.log(err)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.page-container {
  .main-box {
    @include flex-box(flex-start, center);
    flex-direction: column;
    margin-bottom: 22px;
    padding-bottom: 40px;
    overflow: hidden;
    background: $blockBgColor;

    .avatar {
      display: block;
      width: 188px;
      height: 188px;
      margin: 24px auto 0;
    }
  }
}
</style>

